// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vx_a bhc_b bhc_wb"};